export default class Cookiehandler {

  constructor(options = {}) {
    this.$root = options.element;
    this.acceptButton = this.$root.querySelector('.js-cookie-bar-button');
    this.cookieName = 'bfvPermitCookies';
  }

  init() {
    const showDisclaimer = !this.isCookieSet();
    if (showDisclaimer) {
      this.showDisclaimer();
      this.bindEvents();
    }
  }

  bindEvents() {
    this.acceptButton.addEventListener('click', this.setCookie.bind(this));
  }

  isCookieSet() {
    const cookies = document.cookie;
    return cookies.includes(`${this.cookieName}=true`);
  }

  setCookie() {
    const expiration = Cookiehandler.getExpirationDate();

    const expires = `expires=${expiration.toUTCString()}`;
    document.cookie = `${this.cookieName}=true; ${expires}; path=/`;
    this.hideDisclaimer();
  }

  static getExpirationDate() {
    const now = new Date();
    const lifetimeInDays = 365;
    const lifetimeInMilliseconds = lifetimeInDays * 24 * 60 * 60 * 1000;
    return new Date(now.getTime() + lifetimeInMilliseconds);
  }

  showDisclaimer() {
    this.$root.classList.add('cookie-bar--visible');
  }

  hideDisclaimer() {
    this.$root.classList.remove('cookie-bar--visible');
  }
}
